import { forEach, groupBy } from 'lodash'

export default class RangeGroupChunkModel {
  combo = {}
  t = () => {}

  constructor (combo, t) {
    this.combo = combo
    this.t = t
  }

  generateChunkName (chunk) {
    const first = chunk[0]
    const last = chunk[chunk.length - 1]
    if (chunk.length === 1) {
      return first.variationName
    }

    return this.t('variation.chunk.generated.name', {
      params: [{
        first: first.variationName,
        last: last.variationName
      }]
    })
  }

  getAllVariationValueIds (chunk) {
    const allVariationValueIds = []
    forEach(chunk, (variation) => {
      allVariationValueIds.push(variation.variationId)
    })
    return allVariationValueIds
  }

  createChunksForPerCountGroup () {
    const sortedVariationValues = this.combo.variations.sort((a, b) => Number(a.variationOrder) - Number(b.variationOrder))
    const [list, chunkSize] = [sortedVariationValues, this.combo.variationGroupStep]
    const chunkDataEntries = [...Array(Math.ceil(list.length / chunkSize))].map(_ => list.splice(0, chunkSize))

    const chunks = []
    for (const chunkData of chunkDataEntries) {
      chunks.push({
        chunkName: this.generateChunkName(chunkData),
        chunkData,
        chunkValueIds: this.getAllVariationValueIds(chunkData)
      })
    }

    return chunks
  }

  createChunksForPerValueGroup () {
    const sortedVariationValues = this.combo.variations.sort((a, b) => Number(a.variationDisplayValue) - Number(b.variationDisplayValue))
    const step = this.combo.variationGroupStep
    const chunkDataEntries = groupBy(sortedVariationValues, (item) => step * Math.ceil(Number(item.variationDisplayValue) / step))

    const chunks = []
    // eslint-disable-next-line no-unused-vars
    for (const [chunkNameRaw, chunkData] of Object.entries(chunkDataEntries)) {
      chunks.push({
        chunkName: this.generateChunkName(chunkData),
        chunkData,
        chunkValueIds: this.getAllVariationValueIds(chunkData)
      })
    }

    return chunks
  }
}
